import React from 'react';

import { ShowHide as ShowHideShared } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Box, Loader, useTheme } from '@bcp-nextgen-dx-component-factory/design-system';

// to fix not exists children prop in react-18
const ShowHide = ShowHideShared as any;

export const GLOBAL_LOADER = 'loaders.global';

export const GlobalLoader: React.FC = () => {
	const { colorPalette } = useTheme();

	return (
		<ShowHide name={GLOBAL_LOADER}>
			<Box
				styles={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					justifyContent: 'center',
					zIndex: 9999,
					display: 'flex',
					background: colorPalette.color_01[50],
				}}
			>
				<Loader width={150} height={150} />
			</Box>
		</ShowHide>
	);
};
